import { ApiBase } from '../api-base'

export class AttachmentServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/attachments',
      name: 'attachment',
      successPath: '/attachments'
    })
  }

  /**
   * @param {Object} params
   * @param {String} params.attachableType
   * @param {integer} params.attachableId
   * @param {integer} params.attachmentTypeId
   * @param {integer} params.limit
   * @param {string} params.order - ASC or DESC
   * @param {Object} params.period
   * @param {integer} params.period.year
   * @param {integer} params.period.month
   * @returns {Promise}
   *
   */
  index({
    limit = null,
    order = 'DESC',
    attachableType,
    attachableId,
    period = { year: null, month: null },
    attachmentTypeId = null
  }) {
    const params = {
      attachable_type: attachableType,
      attachable_id: attachableId,
      order
    }

    if (attachmentTypeId) {
      params.attachment_type_id = attachmentTypeId
    }

    if (period.year) {
      params['period[year]'] = period.year
    }

    if (period.month) {
      params['period[month]'] = period.month
    }

    if (limit) {
      params.by_limit = limit
    }

    return this.api.get(`${this.resource}`, new URLSearchParams(params))
  }

  getAttachmentTypes({ attachableType = '' }) {
    const params = {}

    if (attachableType) {
      params.by_klass = attachableType
    }

    return this.api.get(
      `${this.resource}/attachment_types`,
      new URLSearchParams(params)
    )
  }
}
